<template>
  <div>
    <input style="display: none" ref="input" type="file" @change="handleFileChange" />
    <h-button
      type="ghost"
      icon="ios-cloud-upload-outline"
      @click="uploadImg"
      :style="{width: '152px' && name ==='上传附件'}"
      :class="{'upload': name ==='上传附件'}"
    >{{name}}</h-button>
    <div v-for="(item, index) in inputImgIlist" :key="index" class="file-item">
      {{ item.name }}
      <span class="file-dele" @click="deleFile(index)"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UploadItem',
  data () {
    return {
      inputImgIlist: []
    }
  },
  props: {
    serviceItem: {},
    name: {
      type: String,
      default: '添加'
    },
    type:{
      type: Array,
      default: () => {
        return ['xls', 'xlsx', 'doc', 'docx', 'rar', 'zip', 'png', 'jpg','jpeg','pdf']
      }
    },
    fileMax:{
      type: Number,
      default: 1024 * 1024 * 5
    },
    fileMaxTip:{
      type: String,
      default:'附件大小不能超过5M'
    }
  },
  created () { },
  watch: {
    $route (to, from) { }
  },
  mounted () {
  },
  methods: {
    //上传图片
    uploadImg () {
      if (this.inputImgIlist && this.inputImgIlist.length > 1) {
        this.$hMessage.warning('最多上传1个附件')
        return
      }
      if (this.inputImgIlist && this.inputImgIlist.length < 2) {
        this.$refs.input.click()
      } else {
        this.$hMessage.warning('最多上传1个附件')
      }
    },
    handleFileChange (event) {
      let file = event.target.files // 获取上传的文件
      let fileNum = file.length
        ? file.length + this.inputImgIlist.length
        : 0 + this.inputImgIlist.length
      let fileMax = this.fileMax //5M
      let types = this.type
      if (fileNum <= 1) {
        if (file && file.length > 0) {
          for (let i = 0; i < file.length; i++) {
            let fileSize = file[i].size
            // 截取文件格式
            let fIndex = file[i].name.lastIndexOf(".")
            let fileType = file[i].name.substr(fIndex + 1)

            if (!types.some(t => t == fileType)) {
              this.$hMessage.warning('文件非法')
              event.target.value = ''
              return
            } else if (fileSize > fileMax) {
              this.$hMessage.warning(this.fileMaxTip||'附件大小不能超过5M')
              event.target.value = ''
              return
            } else {
              this.inputImgIlist.push(file[i])
            }
          }
        } else if (file.length > 1) {
          this.$hMessage.warning('最多上传1个附件')
        }
      } else {
        this.$hMessage.warning('最多上传1个附件')
      }
      event.target.value = ''
    },
    // 删除附件
    deleFile (i) {
      this.inputImgIlist.splice(i, 1)
    }
  },
  components: {
    //SideBar
  }
}
</script>
<style lang="scss" scoped>
.upload {
  width: 152px;
  height: 32px;
}
.file-item {
  font-size: 14px;
  &:before {
    content: '';
    display: inline-block;
    width: 13px;
    height: 11px;
    background: url('~@/assets/component/fujian.png') no-repeat 0 0;
  }
  .file-dele {
    width: 11px;
    height: 12px;
    background: url('~@/assets/component/lajitong.png') no-repeat 0 0;
    display: none;
    margin-left: 25px;
    cursor: pointer;
  }
  &:hover {
    .file-dele {
      display: inline-block;
    }
  }
}
</style>
<style lang="scss">
.upload > .h-icon + span {
  margin: 0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/uploadItem.vue